// Styles for TabContainer go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTabContainer = styled.div`
  padding: 0 ${toRem(16)};
  .tabpage-container {
    .container {
      padding: 0 !important;
    }
  }
  .m-standard-tab-list {
    .m-standard-tab-list-item {
      &:not(:first-child) {
        button {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
  .tab-container-header-section {
    padding: ${toRem(24)} 0;
    p {
      margin-bottom: 0;
      @media ${baseVariables.mediaQuery.sm} {
        font-size: ${toRem(27)};
      }
      @media ${baseVariables.mediaQuery.md} {
        font-size: ${toRem(29)};
      }
    }
  }

  .cl__list-item {
    a {
      font-weight: 700 !important;
      font-size: ${toRem(16)};
    }
  }
  .accordion__container {
    button.accordion__heading {
      padding: ${toRem(24)} 0 !important;
      margin: 0 !important;
      height: ${toRem(80)};
    }
  }
  .tabpage-edge {
    padding-top: ${toRem(24)};
    margin-top: 0;
  }
  .m-accordion__list {
    li {
      height: ${toRem(24)};
      padding-top: 0;
    }
    li:not(:first-child) {
      height: ${toRem(40)};
      padding-top: ${toRem(16)};
    }
  }
  .accordion__list {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: ${toRem(32)};
    padding-bottom: ${toRem(32)};
    width: unset;
    left: 0;
    right: 0;
  }
  .carouselControlType1.tab-controls {
    .left-arrow,
    .right-arrow {
      margin-top: ${toRem(5)} !important;
    }
    .left-arrow,
    .right-arrow,
    .left-arrow.inv-arrow,
    .left-arrow.alt-arrow,
    .right-arrow.inv-arrow,
    .right-arrow.alt-arrow {
      background: none !important;
    }
  }

  .highlight-wrapper {
    overflow: hidden;
  }

  .cards-column-section {
    padding: 0 !important;
  }

  .header-text-cta-styles {
    padding: ${toRem(64)} ${toRem(16)};
  }
  .card-horizontal-container {
    padding: 0 ${toRem(16)};
  }
  @media only ${baseVariables.mediaQuery.md} {
    .header-text-cta-styles {
      padding: ${toRem(64)} 0;
    }
    .card-horizontal-container {
      padding: unset;
    }
  }
`;
